export default __webpack_public_path__ + "static/s3-prologue-bd0ccd813e376a4b1ab28887e6d506ef.webp";